"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _Detail = _interopRequireDefault(require("./components/Detail"));
var _Progress = _interopRequireDefault(require("@/components/Progress"));
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Detail: _Detail.default,
    Progress: _Progress.default
  },
  data: function data() {
    return {
      region: '',
      city: '',
      area: '',
      routePath: '',
      pageName: 'DAStoreList',
      // test 权限还没加，测试用
      uploadFileType: '.xls, .xlsx',
      // 上传表格类型限制
      /** enum */
      regionOptions: [],
      cityOptions: [],
      areaOptions: [],
      addressOptions: [],
      // 地址option
      addressTimer: null,
      // api timer
      /** search group */
      props: {
        multiple: true,
        checkStrictly: true,
        value: 'label'
      },
      searchVal: {
        area: '',
        rtlSapId: '',
        // 客户编号
        rtlFullName: '',
        // 店名
        rtlRtmCategory: '',
        // RTM类型
        retailerType: '',
        // 零售店类别 //这里后端还没定这个字段
        rtlRegionList: [],
        rtlCityList: [],
        rtlDistrictList: [],
        rtlAddress: '',
        // 地址
        empNo: '',
        // SR工号
        empName: '' // SR姓名
      },
      /** table group */
      listLoading: false,
      currPage: 1,
      limit: 10,
      total: 0,
      list: [{
        rtlSapId: '',
        rtlFullName: '',
        rtlRtmCategory: '',
        retailerType: '',
        empNo: '',
        empName: '',
        rtlRegionList: [],
        rtlCityList: [],
        rtlDistrictList: [],
        rtlAddress: ''
      }],
      form: {
        file: null
      },
      sourceApi: null,
      // api timer
      lookupList: {},
      isError: '',
      isShowModel: false,
      isShowProgress: false,
      excelBatchId: '',
      fileImportProcessUniqueCode: '',
      showClose: false,
      showResult: false,
      confirmText: null,
      isLoading: false
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    this.routePath = this.$route.path;
    this.fetchRegionList();
    this.getLookupTypeCode();
  },
  methods: {
    /** 省市区 enum */fetchRegionList: function fetchRegionList() {
      var _this = this;
      if (this.$store.getters.regionData.length) {
        this.regionOptions = this.$store.getters.regionData;
        return;
      }
      this.$api.common.getRegionList(3).then(function (response) {
        var responseData = response;
        if (responseData.success) {
          _this.regionOptions = responseData.data;
          _this.$store.dispatch('baseData/saveRegionData', responseData.data);
        }
      }).catch(function (error) {
        console.log('-----' + error);
      });
    },
    /** search */searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    /**
     * table methods
     */
    // get table list
    fetchData: function fetchData() {
      var _this2 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.listLoading = true;
      this.$api.DAStoreList.getList(param, this.sourceApi.token).then(function (res) {
        _this2.listLoading = false;
        _this2.list = res.data.items;
        _this2.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this2.listLoading = false;
      });
    },
    /** resert table */resetData: function resetData() {
      this.searchVal = this.$options.data().searchVal;
      this.city = '';
      this.area = '';
      this.region = '';
      this.fetchData();
    },
    /** view detail */onView: function onView(row) {
      console.log('view', row);
      // 跳转页面
    },
    handleError: function handleError() {
      this.confirmText = this.$t('common.checkResult');
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this3 = this;
      var param = {
        configItemCodeList: ['STORE_RTM_TYPE', 'STORE_CATEGORY']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        _this3.lookupList = JSON.parse(JSON.stringify(res.data || {}));
        // 查找值数据转换
        for (var key in _this3.lookupList) {
          _this3.generateMapping(key, _this3.lookupList[key] || []);
        }
        _this3.searchData();
      }).catch(function () {
        console.log('Data Request Fail');
      });
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this4 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this4.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    handleClickConfirm: function handleClickConfirm() {
      if (this.confirmText === this.$t('common.checkResult')) {
        this.isShowProgress = false;
        this.isShowModel = true;
      } else {
        this.isShowProgress = false;
      }
    },
    handleEnd: function handleEnd() {
      this.searchData();
    },
    downloadResultExcel: function downloadResultExcel(name) {
      var _this5 = this;
      this.isLoading = true;
      this.$api.DAStoreList.downloadResultExcel({
        batchId: this.excelBatchId
      }).then(function (res) {
        _this5.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this5.isLoading = false;
      });
    },
    downloadExcel: function downloadExcel(name) {
      var _this6 = this;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      this.$api.DAStoreList.export(param).then(function (res) {
        _this6.isLoading = false;
        (0, _index.downloadFileExcel)(name, res.data);
      }).catch(function () {
        _this6.isLoading = false;
      });
    },
    uploadData: function uploadData(file, fileList) {
      var _this7 = this;
      // 数据状态初始化
      this.confirmText = this.$t('common.confirm');
      var rawFile = file.raw;
      if (!rawFile) return;
      if (rawFile.size > 100 * 1024 * 1024) {
        this.$message.error('The file size cannot exceed 100M');
        return;
      }
      this.isLoading = true;
      var param = new FormData();
      param.append('file', rawFile);
      this.$api.DAStoreList.import(param).then(function (res) {
        _this7.isLoading = false;
        _this7.isShowProgress = true;
        _this7.excelBatchId = res.data.excelBatchId;
        _this7.fileImportProcessUniqueCode = res.data.redisKey;
        _this7.showClose = true;
        _this7.$nextTick(function () {
          _this7.$refs['progress'].start();
        });
      }).catch(function (res) {
        _this7.isLoading = false;
      });
    },
    pcdClearEvent: function pcdClearEvent() {
      this.region = [];
      this.city = '';
      this.area = '';
      this.cityOptions = [];
      this.areaOptions = [];
      this.searchVal.rtlRegionList = [];
      this.searchVal.rtlDistrictList = [];
      this.searchVal.rtlCityList = [];
    },
    pcdChangeEvent: function pcdChangeEvent(value) {
      var rtlRegionList = [];
      var rtlCityList = [];
      var rtlDistrictList = [];
      while (value.some(function (item) {
        console.log(item);
        if (item.length === 3) {
          if (rtlRegionList.indexOf(item[0]) === -1) {
            rtlRegionList.push(item[0]);
          }
          if (rtlCityList.indexOf(item[1]) === -1) {
            rtlCityList.push(item[1]);
          }
          if (rtlDistrictList.indexOf(item[2]) === -1) {
            rtlDistrictList.push(item[2]);
          }
        }
        // eslint-disable-next-line no-empty
      })) {}
      this.searchVal.rtlRegionList = rtlRegionList;
      this.searchVal.rtlCityList = rtlCityList;
      this.searchVal.rtlDistrictList = rtlDistrictList;
      console.log('=====val=====', value);
      // this.searchVal.rtlDistrictList = value
    },
    provinceChangeEvent: function provinceChangeEvent(value) {
      this.searchVal.rtlRegionList = [].concat(value.label);
      if (value.children && value.children.length > 0) {
        this.cityOptions = (0, _toConsumableArray2.default)(value.children);
      }
    },
    cityChangeEvent: function cityChangeEvent(value) {
      this.searchVal.rtlCityList = [].concat(value.label);
      if (value.children && value.children.length > 0) {
        this.areaOptions = (0, _toConsumableArray2.default)(value.children);
      }
    },
    areaChangeEvent: function areaChangeEvent(value) {
      while (value.some(function (item) {
        return Array.isArray(item);
      })) {
        value = [].concat.apply([], value);
      }
      this.searchVal.rtlDistrictList = value;
    },
    provinceClearEvent: function provinceClearEvent() {
      this.city = '';
      this.area = '';
      this.cityOptions = [];
      this.areaOptions = [];
      this.searchVal.rtlRegionList = [];
      this.searchVal.rtlDistrictList = [];
      this.searchVal.rtlCityList = [];
    },
    cityClearEvent: function cityClearEvent() {
      this.area = '';
      this.areaOptions = [];
      this.searchVal.rtlDistrictList = [];
    },
    areaClearEvent: function areaClearEvent() {
      this.searchVal.rtlDistrictList = [];
    }
  }
};